import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { BUSINESS } from "@/data/legal";

const NAV_LINKS = [
  { to: "/", label: "Home", testId: "footer-link-home" },
  { to: "/menu", label: "Menu", testId: "footer-link-menu" },
  { to: "/drops", label: "Weekly Drops", testId: "footer-link-drops" },
  { to: "/vault", label: "The Vault", testId: "footer-link-vault" },
  { to: "/membership", label: "Stewardship", testId: "footer-link-membership" },
  { to: "/events", label: "Events", testId: "footer-link-events" },
  { to: "/reserve", label: "The Reserve", testId: "footer-link-reserve" },
  { to: "/obsession-list", label: "Obsession List", testId: "footer-link-obsession" },
  { to: "/chime-in", label: "Chime In", testId: "footer-link-chime-in" },
  { to: "/faq", label: "FAQs", testId: "footer-link-faq" },
];

const ADMIN_LINKS = [
  { to: "/atelier", label: "The Curator's Atelier", testId: "footer-link-atelier" },
  { to: "/admin/notification-settings", label: "Notification Settings", testId: "footer-link-settings" },
];

const LEGAL_LINKS = [
  { to: "/house-alerts", label: "House Alerts", testId: "footer-link-house-alerts" },
  { to: "/privacy", label: "Privacy Policy", testId: "footer-link-privacy" },
  { to: "/terms", label: "Terms of Service", testId: "footer-link-terms" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-bone/10 bg-obsidian">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="label-eyebrow">The Uncanny House</p>
          <h3 className="font-display text-bone text-4xl md:text-5xl mt-4 leading-none">
            Crafted for Obsession.
          </h3>
          <p className="mt-6 max-w-md text-bone/65 text-sm leading-relaxed">
            {BUSINESS.description}
          </p>
          <p className="mt-4 text-bone/45 text-[11px] uppercase tracking-[0.28em]">
            Operated by {BUSINESS.legalName}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="label-eyebrow">Visit</p>
          <ul className="mt-4 space-y-3 text-bone/75 text-sm">
            <li>Currently roaming the American West Coast.</li>
            <li>Booked into 38 private events this year.</li>
            <li>By appointment &amp; invitation.</li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="label-eyebrow">Site</p>
          <ul className="mt-4 space-y-2 text-bone/75 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={l.testId} className="hover:text-brass transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="label-eyebrow">Legal &amp; SMS</p>
          <ul className="mt-4 space-y-2 text-bone/75 text-sm">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={l.testId} className="hover:text-brass transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>

          <p className="label-eyebrow mt-8">Follow</p>
          <a
            href="#"
            data-testid="footer-instagram"
            className="mt-3 inline-flex items-center gap-2 text-bone/75 hover:text-lavender transition-colors text-sm"
          >
            <Instagram size={16} /> @theuncannyhouse
          </a>

          <p className="label-eyebrow mt-8">Admin</p>
          <ul className="mt-3 space-y-2 text-bone/60 text-sm">
            {ADMIN_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={l.testId} className="hover:text-brass transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-bone/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.28em] text-bone/45">
          <p>© {new Date().getFullYear()} {BUSINESS.legalName}. All rights reserved.</p>
          <p>
            <a href={`mailto:${BUSINESS.email}`} className="hover:text-brass transition-colors">{BUSINESS.email}</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
